import { Deserializable } from './deserializable';
import { User } from './user';

export class InteractionsMetadataVisibilityResponse implements Deserializable {
  id: number;
  customerId: number;
  customerName: string;
  key: string;
  visibility: boolean;
  createdAt: Date;
  updatedAt: Date;
  updatedBy: User;

  deserialize(input: any): this {
    Object.assign(this, input);
    if (input.updatedBy) {
      this.updatedBy = new User().deserialize(input.updatedBy);
    }
    return this;
  }
}


